import { useEffect, useState } from "react";
import { api, formatDate } from "@/lib/api";

export default function AdminNewsletterPreview() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/homepage").then(({ data }) => setData(data));
  }, []);

  if (!data) return <div className="text-[#718096]">Зареждане...</div>;

  const digestArticles = data.latest.slice(0, 5);
  const podcast = data.podcasts[0];

  return (
    <div data-testid="admin-newsletter-preview-page">
      <h1 className="font-serif text-3xl font-bold text-[#1A1A1A] mb-2">Digest Preview</h1>
      <p className="text-sm text-[#718096] mb-8 max-w-xl">
        Преглед как ще изглежда седмичният имейл до контактите в Brevo списък &quot;metri.bg&quot;. Това е само визуализация — изпращането на реален digest не е активирано.
      </p>

      <div className="max-w-xl mx-auto border border-[#E2E8F0] shadow-sm" data-testid="newsletter-email-preview">
        <div className="bg-[#111827] text-center py-8">
          <div className="font-serif text-2xl font-extrabold text-white">Metri<span className="text-[#C5A059]">.bg</span></div>
          <div className="text-xs text-[#9CA3AF] uppercase tracking-[0.2em] mt-1">Бюлетин за новини &middot; {formatDate(new Date().toISOString())}</div>
        </div>

        {data.lead && (
          <div className="p-6 border-b border-[#E2E8F0] bg-white" data-testid="newsletter-preview-lead">
            <img src={data.lead.cover_image} alt="" className="w-full aspect-[16/9] object-cover mb-4" />
            <span className="text-xs font-bold uppercase text-[#A6192E]">{data.lead.category_name}</span>
            <h2 className="font-serif text-xl font-bold text-[#1A1A1A] mt-1">{data.lead.title}</h2>
            <p className="text-sm text-[#718096] mt-2">{data.lead.subtitle}</p>
          </div>
        )}

        <div className="p-6 border-b border-[#E2E8F0] bg-white" data-testid="newsletter-preview-latest">
          <h3 className="text-xs font-bold uppercase tracking-wide text-[#718096] mb-4">Тази седмица в Metri.bg</h3>
          <div className="space-y-4">
            {digestArticles.map((a) => (
              <div key={a.id} className="flex gap-3">
                <img src={a.cover_image} alt="" className="w-16 h-16 object-cover flex-shrink-0" />
                <div>
                  <span className="text-[10px] font-bold uppercase text-[#A6192E]">{a.category_name}</span>
                  <div className="text-sm font-semibold text-[#1A1A1A] leading-snug">{a.title}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {podcast && (
          <div className="p-6 border-b border-[#E2E8F0] bg-[#F4F1EC]" data-testid="newsletter-preview-podcast">
            <h3 className="text-xs font-bold uppercase tracking-wide text-[#718096] mb-3">Нов епизод</h3>
            <div className="flex gap-3 items-center">
              <img src={podcast.thumbnail} alt="" className="w-20 aspect-video object-cover" />
              <div className="text-sm font-semibold text-[#1A1A1A]">{podcast.title}</div>
            </div>
          </div>
        )}

        <div className="p-6 text-center text-xs text-[#9CA3AF] bg-white">
          Получавате този имейл, защото сте се абонирали за Metri.bg Бюлетин за новини.<br />
          Metri.bg &middot; част от екосистемата на Investivo
        </div>
      </div>
    </div>
  );
}
